<template>
  <div class="btn" :style="style">
    <p class="btnLeft" :class="id > 0 && stopId ? 'pitch' : ''" @click="preBtn">
      <arrow-left-outlined class="icon" />
    </p>
    <p class="btnLeft btnRight" :class="id < stopId - 1 && stopId ? 'pitch' : ''" @click="nextBtn">
      <arrow-right-outlined class="icon" />
    </p>
  </div>
</template>

<script setup>
import { ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons-vue'
import { ref, computed } from 'vue'
const props = defineProps(['navArr', 'style', 'pitchId', 'stopId'])
const emit = defineEmits(['fetchNav'])
const id = ref(props.pitchId || 0)
const navArr = props.navArr || {}
const style = props.style || {}

const stopId = computed(() => {
  return props.stopId || props.navArr.length
})

function preBtn() {
  if (id.value < 1) return
  id.value--
  emit('fetchNav', id.value)
}
function nextBtn() {
  if (id.value >= stopId.value - 1) return
  if (navArr === {}) return
  id.value++
  emit('fetchNav', id.value)
}
</script>

<style lang="scss" scoped>
.pitch {
  cursor: pointer !important;
  pointer-events: auto;
  background: #00ab7a;
  border: 0px !important;
  &:hover {
    color: #fff;
    background: #00825d;
  }
}
.btn {
  &Left {
    position: relative;
    display: inline-block;
    width: 68px;
    height: 48px;
    border: 1px solid #e2e6ed;
    color: #e2e6ed;
    margin: 0 8px 0;
    cursor: not-allowed;
  }
  &Right {
    margin: 0;
  }
  .icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 25px;
  }
}
</style>
